import { render, staticRenderFns } from "./ProjectNumList.vue?vue&type=template&id=60b6d2a1&scoped=true&"
import script from "./ProjectNumList.vue?vue&type=script&lang=js&"
export * from "./ProjectNumList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNumList.vue?vue&type=style&index=0&id=60b6d2a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6d2a1",
  null
  
)

export default component.exports